/* const initialQueueState = [];

function queueReducer(state = initialQueueState, action) {
  switch (action.type) {
    case 'QUEUE_REQUEST':
      return [...state, action.payload];
    case 'CLEAR_QUEUE':
      return [];
    default:
      return state;
  }
}

export default queueReducer; */

import { appActions } from "./Actions"
import { success } from "../utils/Reducers"

export const initialState = {
  isLoading: false,
  error: null,
  dataToSend: []
}

export default function (state = initialState, action) {
  if (appActions) {
    switch (action.type) {
      case "QUEUE_REQUEST":
        state = success(state, { dataToSend: state.dataToSend.concat(action.payload) })
        break
      case "REMOVE_QUEUE":
        const newArray = state.dataToSend?.filter((_, index) => index !== action.payload?.index);
        state = success(state, { dataToSend: newArray })
        break
        case "CLEAR_QUEUE":
          state = initialState
          break
      default:
        break
    }
  }
  return state
}
